import { render } from "./RelatorioFornecedor.vue?vue&type=template&id=46776a5b"
import script from "./RelatorioFornecedor.vue?vue&type=script&lang=js"
export * from "./RelatorioFornecedor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__